import { render, staticRenderFns } from "./personal-homepage.vue?vue&type=template&id=55e6d6e8&scoped=true&"
import script from "./personal-homepage.vue?vue&type=script&lang=js&"
export * from "./personal-homepage.vue?vue&type=script&lang=js&"
import style0 from "./personal-homepage.vue?vue&type=style&index=0&id=55e6d6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6d6e8",
  null
  
)

export default component.exports